module.exports = __webpack_public_path__ + "media/components/icons/SVG/pin-f2ce81e6ef39242b56a8d4209cf699ab.svg";